import { Controller, Get, Post, Body, Patch, Param, Delete, Header } from '@nestjs/common';
import { ItemconfigurationService } from './itemconfiguration.service';
import { CreateItemconfigurationDto } from './dto/create-itemconfiguration.dto';
import { UpdateItemconfigurationDto } from './dto/update-itemconfiguration.dto';

@Controller('items')
export class ItemconfigurationController {
  constructor(private readonly itemconfigurationService: ItemconfigurationService) { }

  @Post('send')
  create(@Body() createItemconfigurationDto: CreateItemconfigurationDto) {
    return this.itemconfigurationService.create(createItemconfigurationDto);
  }

  @Get('get')
  async findAll() {
    // const buffer = await this.itemconfigurationService.findAll();
    return await this.itemconfigurationService.findAll();
  }

  // @Get(':id')
  // findOne(@Param('id') id: string) {
  //   return this.itemconfigurationService.findOne(+id);
  // }

  // @Patch(':id')
  // update(@Param('id') id: string, @Body() updateItemconfigurationDto: UpdateItemconfigurationDto) {
  //   return this.itemconfigurationService.update(+id, updateItemconfigurationDto);
  // }

  // @Delete(':id')
  // remove(@Param('id') id: string) {
  //   return this.itemconfigurationService.remove(+id);
  // }
}
